/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * rain/v1/thread_service.proto
 * OpenAPI spec version: version not set
 */

/**
 * Error kind for generation failures.
Maps to GenerationErrorKind enum in rain-event.

 - GENERATION_ERROR_KIND_UNSPECIFIED: Unspecified error kind.
 - GENERATION_ERROR_KIND_CONTEXT_TOO_LONG: Input context exceeds the model's maximum token limit.
 - GENERATION_ERROR_KIND_PROVIDER_ERROR: Upstream provider returned an error.
 - GENERATION_ERROR_KIND_API_ERROR: API-level error from the provider.
 - GENERATION_ERROR_KIND_CONTENT_FILTERED: Response was filtered by content safety policies.
 - GENERATION_ERROR_KIND_LENGTH_LIMIT_EXCEEDED: Output exceeded the maximum length limit.
 - GENERATION_ERROR_KIND_INVALID_REQUEST: Request was malformed or invalid.
 - GENERATION_ERROR_KIND_RATE_LIMIT_EXCEEDED: Rate limit was exceeded.
 - GENERATION_ERROR_KIND_SERIALIZATION_ERROR: Failed to serialize or deserialize data.
 - GENERATION_ERROR_KIND_STREAM_ERROR: Error occurred during response streaming.
 - GENERATION_ERROR_KIND_CONFIGURATION_ERROR: Generator configuration is invalid.
 - GENERATION_ERROR_KIND_INTERNAL_ERROR: Internal server error.
 - GENERATION_ERROR_KIND_STOPPED: Generation was stopped by the user or system.
 - GENERATION_ERROR_KIND_SHUTDOWN: Server is shutting down.
 - GENERATION_ERROR_KIND_AUTHENTICATION: Authentication failed (invalid/missing credentials).
 - GENERATION_ERROR_KIND_OVERLOADED: Provider is overloaded / temporarily unavailable.
 - GENERATION_ERROR_KIND_STREAM_DROPPED: Stream ended mid-response without a terminal event (mid-stream drop).
Distinct from STREAM_ERROR (transient transport blips that may
succeed on retry): once partial tokens have been delivered to the
user, retrying produces a different response that won't align with
what's already shown. Non-retryable by classification.
 - GENERATION_ERROR_KIND_LOST: The server lost this generation: the process running it died
mid-turn, and the failure was synthesized afterwards to close out
the dangling thread tail. Distinct from STOPPED (a user action)
and from provider errors — nothing was wrong with the request.
 - GENERATION_ERROR_KIND_REQUEST_TOO_LARGE: The request payload exceeded the platform's request-size limit (e.g.
Bedrock's 20 MB / direct API 32 MB cap), distinct from CONTEXT_TOO_LONG
(a token-window overflow). Recoverable by offloading large tool results
out of context and retrying.
 */
export type V1GenerationErrorKind =
  (typeof V1GenerationErrorKind)[keyof typeof V1GenerationErrorKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1GenerationErrorKind = {
  GENERATION_ERROR_KIND_UNSPECIFIED: 'GENERATION_ERROR_KIND_UNSPECIFIED',
  GENERATION_ERROR_KIND_CONTEXT_TOO_LONG:
    'GENERATION_ERROR_KIND_CONTEXT_TOO_LONG',
  GENERATION_ERROR_KIND_PROVIDER_ERROR: 'GENERATION_ERROR_KIND_PROVIDER_ERROR',
  GENERATION_ERROR_KIND_API_ERROR: 'GENERATION_ERROR_KIND_API_ERROR',
  GENERATION_ERROR_KIND_CONTENT_FILTERED:
    'GENERATION_ERROR_KIND_CONTENT_FILTERED',
  GENERATION_ERROR_KIND_LENGTH_LIMIT_EXCEEDED:
    'GENERATION_ERROR_KIND_LENGTH_LIMIT_EXCEEDED',
  GENERATION_ERROR_KIND_INVALID_REQUEST:
    'GENERATION_ERROR_KIND_INVALID_REQUEST',
  GENERATION_ERROR_KIND_RATE_LIMIT_EXCEEDED:
    'GENERATION_ERROR_KIND_RATE_LIMIT_EXCEEDED',
  GENERATION_ERROR_KIND_SERIALIZATION_ERROR:
    'GENERATION_ERROR_KIND_SERIALIZATION_ERROR',
  GENERATION_ERROR_KIND_STREAM_ERROR: 'GENERATION_ERROR_KIND_STREAM_ERROR',
  GENERATION_ERROR_KIND_CONFIGURATION_ERROR:
    'GENERATION_ERROR_KIND_CONFIGURATION_ERROR',
  GENERATION_ERROR_KIND_INTERNAL_ERROR: 'GENERATION_ERROR_KIND_INTERNAL_ERROR',
  GENERATION_ERROR_KIND_STOPPED: 'GENERATION_ERROR_KIND_STOPPED',
  GENERATION_ERROR_KIND_SHUTDOWN: 'GENERATION_ERROR_KIND_SHUTDOWN',
  GENERATION_ERROR_KIND_AUTHENTICATION: 'GENERATION_ERROR_KIND_AUTHENTICATION',
  GENERATION_ERROR_KIND_OVERLOADED: 'GENERATION_ERROR_KIND_OVERLOADED',
  GENERATION_ERROR_KIND_STREAM_DROPPED: 'GENERATION_ERROR_KIND_STREAM_DROPPED',
  GENERATION_ERROR_KIND_LOST: 'GENERATION_ERROR_KIND_LOST',
  GENERATION_ERROR_KIND_REQUEST_TOO_LARGE:
    'GENERATION_ERROR_KIND_REQUEST_TOO_LARGE',
} as const;
